import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const nexaReceiversSlice = createSlice({
    name: 'nexa_receivers',
    initialState,
    reducers: {
        nexaReceiversCleared: () => {
            return {};
        },
        nexaReceiverUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        nexaReceiverDeleted: (state, action) => {
            delete state[action.payload];
        },
        nexaReceiversReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.nexa_receivers) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectNexaReceivers = (state) => state.definitions.nexa_receivers;
export const selectNexaReceiver = (id) => (state) => id == undefined ? undefined : state.definitions.nexa_receivers[id];
export const { nexaReceiversCleared, nexaReceiverUpdated, nexaReceiverDeleted, nexaReceiversReplaced } = nexaReceiversSlice.actions;
export const nexaReceiverAdded = nexaReceiverUpdated;
export default nexaReceiversSlice.reducer;
